module.exports = __webpack_public_path__ + "img/header_bg.12d512c3.png";